module.exports = __webpack_public_path__ + "img/맑음.075c56cb.png";